import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import SpotlightSlider from "./SpotlightSlider";
import PrescriptionOptions from "./Priscription/PrescriptionOptions";
import PopularTest from "./PopularTest";
import SpecializedBanner from "./SpecializedBanner";
import ShopByCategory from "./ShopByCategory";
import AfterCategoryBanner from "./AfterCategoryBanner";
import FeaturedBrands from "./FeaturedBrands";
import OfferForYou from "./OfferForYou";
import Package from "../LabTest/Packages";
import TrendingToday from "./TrendingToday";
import NewBanner from "./NewBanner";
import CategorySection from "./CategoreySection.js";
import HealthConditions from "./HealthConditions";
import HowItWorks from "./HowItWorks";
import WhyChooseUs from "./WhyChooseUs.js";
import GetPartner from "./Partner/GetPartner";
import LoginPopup from "../common/LoginPopup"; // 👈 add

export default function AllFillter() {
  const [showLogin, setShowLogin] = useState(false); // 👈 add

  return (
    <div
      className="w-full min-h-screen bg-slate-50/50 pb-16"
      style={{ overflowX: "hidden" }}
    >
      <div className="w-full max-w-[1720px] mx-auto px-3 sm:px-6 lg:px-10 xl:px-12 space-y-6 md:space-y-8 pt-2">
        <SpotlightSlider />
        <CategorySection />
        <PrescriptionOptions setShowLogin={setShowLogin} />
        <HealthConditions />
        <PopularTest />
        <SpecializedBanner />
        <Package /> 
        <HowItWorks />
        <OfferForYou />
        <GetPartner />
        <WhyChooseUs />
      </div>

      {/* 👇 Login Popup */}
      <LoginPopup
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
      />
    </div>
  );
}